import { createContext, useContext } from "react";

import type {
  CashRegisterConfiguration,
  EmailSettings,
  MollieConfiguration,
  PreparationTicketSettings,
  ReceiptSettings,
  RevenueReportSettings,
} from "~/providers/configuration-provider";

interface ConfigurationContext {
  mollieConfiguration?: MollieConfiguration;
  receiptSettings: ReceiptSettings[];
  revenueReportSettings: RevenueReportSettings;
  preparationTicketSettings: PreparationTicketSettings;
  cashRegisterConfiguration?: CashRegisterConfiguration;
  emailSettings?: EmailSettings;
}

export const ConfigurationContext = createContext<
  ConfigurationContext | undefined
>(undefined);

export const useConfiguration = () => {
  const context = useContext(ConfigurationContext);

  if (context === undefined) {
    throw new Error(
      "useConfiguration must be used within a ConfigurationProvider, but no provider was found",
    );
  }

  return context;
};
